export default __webpack_public_path__ + "7784c670a90b3077c0b6bccd8e767556.png";